import React, {  } from "react";


import { _etap_plikow, _status_wydania_papieru, _typ_elementu } from "utils/initialvalue";
import style from "../ProcesViewRow.module.css";
import { _status } from "utils/initialvalue";

// import TytulProcesGrup from "./components/TytulProcesGrup";


export default function TytulProcesGrup ({ grup }) {
  //nazwa_elementu
  const czyPokazacArkusze = grup.arkusze_numery && grup.arkusze_numery !== "" && grup.proces_nazwa_id != 1;
  return (
    <td>
    <input
      //firma_nazwa to skrocona nazwa klienta
      title={grup.Praca}
      className={style.tytulInput}
      // value={grup.nr_stary+ " "+grup.tytul +' '+grup.nazwa_elementu+" ark: "+grup.arkusze_numery }
      // value={`${grup.nr_stary} ${grup.tytul} ${grup.nazwa_elementu}${grup.proces_nazwa_id != 1 ? ` ark: ${grup.arkusze_numery}` : ''}`}
      // value={`${grup.nr_stary} ${grup.tytul} ${grup.nazwa_elementu}${grup.proces_nazwa_id != 1 ? ` ark: ${grup.arkusze_numery}` : ''}`}
      value={`${grup.nr_stary} ${grup.tytul} ${grup.nazwa_elementu}${czyPokazacArkusze ? ` ark: ${grup.arkusze_numery}` : ''}`}
      readOnly

    />
    </td>
  );
};